export default new class Banner {
    init() {
		this.initBanner();
	}

	// Scroll : add or remove class "scrolled" in the "js-banner"
    initBanner() {
		let scrollPos = window.scrollY;
		const banner = document.querySelector('.js-banner');
		const scrollChange = 100;

		if (banner) {
			const addClassOnScroll = function () {
				banner.classList.add('scrolled');
			}
			const removeClassOnScroll = function () {
				banner.classList.remove('scrolled');
			}
			window.addEventListener('scroll', function () {
				scrollPos = window.scrollY;

				if (scrollPos >= scrollChange) { addClassOnScroll() } else { removeClassOnScroll() }
			});
		}
	}
}